<template>
  <ul class="menu-list">
    <li v-for="(item, index) in menu.list" :key="index" class="menu-list__item">
      <div :menu-route="item.route"
           :title="item.title"
           class="menu-list__link"
           @click.prevent="switchMenu"
      >
        <div class="section-icon">
          <AppMenuIcon :title="item.title"/>
        </div>
        <p class="menu-list__text">{{ item.title }}</p>
      </div>
    </li>
  </ul>
</template>

<script>
import AppMenuIcon from '@/components/menu/AppMenuIcon'
export default {
  name: 'AppMenuListMain',
  components: { AppMenuIcon },
  computed: {
    menu () {
      return this.$store.getters.mainMenu
    }
  },
  methods: {
    switchMenu (event) {
      const menu = event.currentTarget.getAttribute('menu-route')
      this.$store.dispatch('switchMenu', { menu: menu, isSubmenu: false })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.menu-list {
  animation: fadeIn .3s ease-in;

  &__link {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding: 5px 15px;
    transition: .3s;
    color: $font_color_six;
    cursor: pointer;

    &:hover {
      background-color: $color__orange;
      color: $color__white;

      .section-icon {
        box-shadow: none;
      }
    }
  }

  &__text {
    margin-left: 20px;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }
}
</style>
